import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './auth'
import { auth } from './firebase'
import { Actionsheet, Field, Tabbar, TabItem } from 'mint-ui'
Vue.component(Actionsheet.name, Actionsheet)
Vue.component(Field.name, Field)
Vue.component(Tabbar.name, Tabbar)
Vue.component(TabItem.name, TabItem)

import 'mint-ui/lib/style.css'
import './assets/css/mint-ui.scss' //Modify the mint-ui style globally

import VueTailwind from 'vue-tailwind'
import settings from '../vue-tailwind.config'
Vue.use(VueTailwind, settings)

Vue.config.productionTip = false

let app
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
